module.exports = __webpack_public_path__ + "static/img/platform-2.6f9c7d1a.png";